

import { Header } from '@/components';
import {
  ImgNews, TextNews, ThemeDayNews, Activity, Company, ClassRoom, Exposition, VideoMatch,
} from './components';
import React from 'react';
import styles from './index.less';
import { Forum } from './components';
import indexFooter from '@/assets/image/indexFooter.png';

interface IHomeProps {

}

const Home: React.FC<IHomeProps> = (props) => {
  return (
    <div className={styles.home}>
      {/* 右上角菜单栏 */}
      <Header isHome />

      {/* 顶部banner图 */}
      <div className={styles.banner}>
        <img src="https://s.newscdn.cn/file/2022/09/8ca64696-00eb-4da5-8c5a-8b1367142d51.jpg" alt="" />
      </div>

      {/* 图片新闻 */}
      <div className={styles.imgNewsW}>
        <ImgNews />
      </div>

      {/* 主题日新闻 */}
      <ThemeDayNews title="热点资讯" style={{ marginBottom: 16 }} />

      {/** 各地新闻 */}
      <TextNews
        title="各地动态"
        style={{ marginBottom: 30 }}
        showBorderBottom
      />

      {/* 日程 */}
      <div className={styles.activity}>
        <Activity />
      </div>

      {/* 网络安全技术高峰论坛 */}
      <Forum />

      {/* 网络安全博览会 */}
      <Exposition />

      {/* 企业列表 */}
      <div className={styles.companyList}>
        <Company />
      </div>

      {/* 网络安全微视频大赛 */}
      <VideoMatch style={{ marginBottom: 30 }} />

      {/* 网络云课堂 */}
      <div className={styles.classRoom}>
        <ClassRoom />
      </div>

      {/* 底部footer */}
      <div className={styles.footer}>
        <img src={indexFooter} alt="" />
      </div>
    </div>
  );
};

export default Home;
